import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../layer/ILoaderProps';
import { LoadableSource } from '../../layer/LoadableSource';
import { Config } from '../../../Config';

// Mixes a #rrggbb color with white; amount 0 leaves it unchanged, 1 is white.
const lighten = (color: string, amount: number) => 
  '#' + [1, 3, 5]
    .map(i => parseInt(color.substr(i, 2), 16))
    .map(c => Math.round(c + (255 - c) * amount).toString(16).padStart(2, '0'))
    .join('');

// Outlines are a brighter version of their polygon's fill color.
const OUTLINE_LIGHTEN = 0.4;

const OnshoreAquaculture = (props: ILoaderProps) => 
  <LoadableSource path="https://apigeostore.longline.co.uk/dataset/595dc6f65323f88a5182e557599d3f3328eb6aba" {...props}>
    <Layer
      id='onshore_aquaculture'
      beforeId={Config.UI.before_layer}
      type='fill'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{ 
        'fill-color': [
          'case',
          ['==', ['get', 'suitability'], 1], Config.suitability[1].color,
          ['==', ['get', 'suitability'], 2], Config.suitability[2].color,
          ['==', ['get', 'suitability'], 3], Config.suitability[3].color,
          ['==', ['get', 'suitability'], 4], Config.suitability[4].color,
          Config.suitability[0].color,
        ],
        'fill-opacity': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          0.8,
          0.5
        ]
      }}
    />
    {/* Outlines are a brighter version of the fill (gold when hovered). They
        are very thin up to zoom 8, where outlining each of the 
        ~170,000 rings at full width would clutter the map, and thicken 
        to full width at zoom 10, where a ~300 m data pixel is a few screen 
        pixels wide. The hover outline stays clearly visible at every zoom. */}
    <Layer
      beforeId={Config.UI.before_layer}
      type='line'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{
        "line-color": [
          'case',
          ['boolean', ['feature-state', 'hover'], false], 'gold',
          ['==', ['get', 'suitability'], 1], lighten(Config.suitability[1].color, OUTLINE_LIGHTEN),
          ['==', ['get', 'suitability'], 2], lighten(Config.suitability[2].color, OUTLINE_LIGHTEN),
          ['==', ['get', 'suitability'], 3], lighten(Config.suitability[3].color, OUTLINE_LIGHTEN),
          ['==', ['get', 'suitability'], 4], lighten(Config.suitability[4].color, OUTLINE_LIGHTEN),
          lighten(Config.suitability[0].color, OUTLINE_LIGHTEN),
          ],
        'line-width': [
          'interpolate', ['linear'], ['zoom'],
          8,  ['case', ['boolean', ['feature-state', 'hover'], false], 1.5, 0.25],
          10, ['case', ['boolean', ['feature-state', 'hover'], false], 3, 1]
          ]
      }}
    />
  </LoadableSource>

export { OnshoreAquaculture } 
